import { create } from 'zustand'
export const useViewStore = create((set) => ({
    view: 0,
    setView: (index) => set((state) => ({ view: index })),
}))
